(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-product-gsgp"] && !Shopify.designMode) return;
  try {
    

        const parallaxImages = gsap.utils.toArray(".index-product-gsgp-js .image-card-hover");

        let HairIndex = document.querySelector(".index-product-gsgp-js"); 
        HairIndex.addEventListener("mousemove", parallax);
        
        function parallax(e) {
          parallaxImages.forEach(function (img) {
            var moving_value = img.dataset.value;
            var x = (e.clientX * moving_value) / 250;
            var y = (e.clientY * moving_value) / 250;
            gsap.set(img, { x });
            gsap.set(img, { y });
          });
        }

      const parallaxImages2 = gsap.utils.toArray(".nova-gsgp-section .image-card-hover");

        let HairIndex2 = document.querySelector(".nova-gsgp-section"); 
        HairIndex2.addEventListener("mousemove", parallax2);
        
        function parallax2(e) {
          parallaxImages2.forEach(function (img) {
            var moving_value = img.dataset.value;
            var x = (e.clientX * moving_value) / 250;
            var y = (e.clientY * moving_value) / 250;
            gsap.set(img, { x });
            gsap.set(img, { y });
          });
        }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iris-vs"] && !Shopify.designMode) return;
  try {
    
  var analysis_table_dom = document.querySelector(".iris-vs");
  var analysis_item_dom = document.querySelector(".iris-vs .analysis-item");
  var see_more_dom = document.querySelector(".analysis-btns .btns-lf");
  var lf_dom = document.querySelector(".analysis-btns .btns-row .btn-box:nth-child(1)");
  var rt_dom = document.querySelector(".analysis-btns .btns-row .btn-box:nth-child(2)");
  var currentIndex = 0;
  var item_width = analysis_item_dom.offsetWidth;
  
  see_more_dom.onclick = function() {
    if (this.classList.contains('unfold')) {
      this.classList.remove('unfold');
      analysis_table_dom.style.height = '480px';
    } else {
      this.classList.add('unfold');
      analysis_table_dom.style.height = 'auto';
    }
  }
  
  lf_dom.onclick = function() {
    currentIndex = currentIndex < 1 ? 3 : currentIndex - 1;
    analysis_table_dom.scrollLeft = item_width * currentIndex;
  }
  rt_dom.onclick = function() {
    currentIndex = currentIndex > 2 ? 0 : currentIndex + 1;
    analysis_table_dom.scrollLeft = item_width * currentIndex;
  }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nova-vs"] && !Shopify.designMode) return;
  try {
    
  var analysis_table_dom = document.querySelector(".iris-vs");
  var analysis_item_dom = document.querySelector(".iris-vs .analysis-item");
  var see_more_dom = document.querySelector(".analysis-btns .btns-lf");
  var lf_dom = document.querySelector(".analysis-btns .btns-row .btn-box:nth-child(1)");
  var rt_dom = document.querySelector(".analysis-btns .btns-row .btn-box:nth-child(2)");
  var currentIndex = 0;
  var item_width = analysis_item_dom.offsetWidth;
  
  see_more_dom.onclick = function() {
    if (this.classList.contains('unfold')) {
      this.classList.remove('unfold');
      analysis_table_dom.style.height = '480px';
    } else {
      this.classList.add('unfold');
      analysis_table_dom.style.height = 'auto';
    }
  }
  
  lf_dom.onclick = function() {
    currentIndex = currentIndex < 1 ? 3 : currentIndex - 1;
    analysis_table_dom.scrollLeft = item_width * currentIndex;
  }
  rt_dom.onclick = function() {
    currentIndex = currentIndex > 2 ? 0 : currentIndex + 1;
    analysis_table_dom.scrollLeft = item_width * currentIndex;
  }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snow-area"] && !Shopify.designMode) return;
  try {
    
    const getSnowflakeCount = () => {
        let width = window.screen.width;

        if (width < 768) return 300;
        if (width < 1024) return 800;

        return 1000;
    };

    const letItSnow = () => {
        const snowflakeArea = document.querySelector(".snowflake-area");

        for (let i = 0; i < getSnowflakeCount(); i++) {
            const snowflake = document.createElement("div");
            snowflake.classList.add("snowflake");

            const randomSize = Math.random() * 4 + 1;
            const randomDuration = Math.random() * 11 + 4;
            const randomXPosition = Math.random() * 100;
            const randomDelay = Math.random() * 6;
            const randomOpacity = Math.random() * 0.2 + 0.4;

            snowflake.style.left = `${randomXPosition}%`;
            snowflake.style.animationDuration = `${randomDuration}s`;
            snowflake.style.width = `${randomSize}px`;
            snowflake.style.animationDelay = `${randomDelay}s`;
            snowflake.style.opacity = `${randomOpacity}`;

            snowflakeArea.appendChild(snowflake);
        }
    };

    letItSnow();


  } catch(e) { console.error(e); }
})();
})();
